
import {
  Summon, 
  Creature, 
  CreatureDetails
} from "@dndModels";

/**
 * This is a helper to summon controls.  
 * It holds specific creatures, or a SummonStatBlock, 
 * along with how many will be summoned.
 */
export class SummonOption2 implements CreatureDetails {
  custom_stat_block: Summon | null = null;
  creature: Creature | null = null;
  count = 0;
  description = "";
  get tags() {
    const tags: string[] = [];
    if (this.custom_stat_block) {
      tags.push(...this.custom_stat_block.tags);
    }
    if (this.creature) {
      tags.push(...this.creature.tags);
    }
    return tags;
  }

  get challenge_rating() {
    if (this.creature) {
      return this.creature.challenge_rating;
    } 
    return 0;
  }

  get _id() {
    if (this.creature) {
      return this.creature._id;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.true_id;
    }
    return "";
  }

  get creature_type() {
    if (this.creature) {
      return this.creature.creature_type;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.creature_type;
    }
    return "None";
  }
  get age_category() {
    if (this.creature) {
      return this.creature.age_category;
    } 
    return "";
  }
  get size_num() {
    if (this.creature) {
      return this.creature.size_num;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.size_num;
    }
    return -1;
  }
  get min_challenge_rating() {
    if (this.creature) {
      return this.creature.min_challenge_rating;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.challenge_rating.base;
    }
    return 0;
  }
  get max_challenge_rating() {
    if (this.creature) {
      return this.creature.max_challenge_rating;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.challenge_rating.base;
    }
    return 0;
  }
  get flying() {
    if (this.creature) {
      return this.creature.flying;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.flying;
    }
    return false;
  }
  get swimming() {
    if (this.creature) {
      return this.creature.swimming;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.swimming;
    }
    return false;
  }

  get subtypes() {
    if (this.creature) {
      return this.creature.subtypes;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.subtypes;
    }
    return [];
  }

  get swarm() {
    if (this.creature) {
      return this.creature.swarm;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.swarm;
    }
    return false;
  }

  get name() {
    if (this.creature) {
      return this.creature.name;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.name;
    }
    return "";
  }
}